import { SearchQueryOrderDirection, Space } from "types/generated";

import { FilterItemKeys } from "./constants";

export const getSortPredicate =
  (
    sortBy: FilterItemKeys,
    sortDirection: SearchQueryOrderDirection,
    childCounts?: Record<string, number>
  ) =>
  (a: Space, b: Space) => {
    if (sortBy === FilterItemKeys.CHILDREN) {
      const countA = childCounts?.[a.id] ?? 0;
      const countB = childCounts?.[b.id] ?? 0;

      return sortDirection === SearchQueryOrderDirection.Asc ? countA - countB : countB - countA;
    }

    const key = sortBy as Exclude<FilterItemKeys, FilterItemKeys.CHILDREN>;
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortDirection === SearchQueryOrderDirection.Asc
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    if (typeof valueA === "boolean" && typeof valueB === "boolean") {
      return sortDirection === SearchQueryOrderDirection.Asc
        ? Number(valueA) - Number(valueB)
        : Number(valueB) - Number(valueA);
    }

    return 0;
  };
